import { hyphenateSync } from 'hyphen/is';

export function hyphenate(str?: string | null) {
  if (!str) return null;
  return hyphenateSync(String(str || ''));
}
